import $ from 'gridstrap/lib/gs-zepto';

export class GSBottomBar {

	//
	// Properties
	//

	root;
	document;
	window;
	body;
	offset;

	get scrollPos() { return this.window.scrollTop(); }
	set isVisible(value) { this.root.toggleClass('is-visible', !!value); }
	set isDismissed(value) { this.root.toggleClass('is-dismissed', !!value); }

	//
	// Methods
	//

	dismiss(evt) {
		this.root.one('animationend', () => this.root.remove());
		this.isDismissed = true;
	}

	private check(evt) {
		if (this.scrollPos >= this.offset) {
			this.isVisible = true;
			this.document.off('scroll.bottombar');
		}
	}

	//
	// Initializations & Event Listeners
	//

	constructor(root) {
		this.root = $(root);
		this.document = $(document);
		this.window = $(window);
		this.body = $('body');
		this.offset = this.root.data('gsBottomBarOffset') || 150;

		this.body.addClass('has-bottombar');

		this.document.on('scroll.bottombar', evt => this.check(evt));
		this.root.on('click', '[role~="close"]', evt => this.dismiss(evt));
	}

	gsOnDestroy() {
		this.body.removeClass('has-bottombar');
		this.document.off('scroll.bottombar');
	}
}
